import * as SCORING_TAG from '../../../constants/scoring-tags';

const bootstrapScore = (event) =>
	event.participants.reduce((acc, curr) => {
		acc[curr.participatable.id] = {
			participant: curr,
			value:       0,
		};
		return acc;
	}, {});

const getScore = ({ event, tags, timestamp }) => {
	const result = bootstrapScore(event);

	const filteredTags = tags.filter((currentTag) => Object.values(SCORING_TAG).includes(currentTag.tag.name) && currentTag.timestamp < timestamp);
	for (const tag of filteredTags) {
		if (!tag.team) continue;
		if (result[tag.team.id]) result[tag.team.id].score += 1;
		else {
			result[tag.team.id] = {
				participant: tag.team,
				score:       0,
			};
		}
	}

	return result;
};

const getScoreZones = ({ event, tags }) => {
	const result = [];
	result.push({ start: 0, end: Number.POSITIVE_INFINITY, score: bootstrapScore(event) });

	const filteredTags = tags.filter((currentTag) => Object.values(SCORING_TAG).includes(currentTag.tag.name));
	filteredTags.sort((a, b) => a.timestamp - b.timestamp);

	for (const tag of filteredTags) {
		const start = tag.timestamp;
		const prev = result[result.length - 1];
		prev.end = start;
		const score = Object.entries(prev.score).reduce((acc, [k, v]) => {
			acc[k] = { ...v };
			return acc;
		}, {});

		if (!score[tag.team?.id]) continue;
		score[tag.team.id].value = prev.score[tag.team.id].value + 1;

		result.push({ start, end: Number.POSITIVE_INFINITY, score });
	}

	if (result.length === 0) return [{ start: 0, end: Number.POSITIVE_INFINITY, score: bootstrapScore(event) }];

	return result;
};

export { getScore, getScoreZones };
